export default "__VITE_ASSET__BebTjV8P__"